import React from 'react';
import { OrderingSelectors, OrderingOperations, OrderingConstants } from 'polygon-ordering';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import Switch from './Switch';
import EVENTS from '../constants/events';
import { logEvent } from '../utils/analytics';
import Text from './Text';
import TouchableOpacity from './TouchableOpacity';

const { getRememberCreditCard, getMember, getEnabledPaymentMethods } = OrderingSelectors;
const { setRememberCreditCard } = OrderingOperations;
const { PAYMENT_METHOD } = OrderingConstants;

const SaveCardSwitch: React.FC = () => {
  const rememberCreditCard = useAppSelector(getRememberCreditCard);
  const checkoutInProgress = useAppSelector(state => state.checkoutInProgress);
  const member = useAppSelector(getMember);
  const enabledPaymentMethods = useAppSelector(getEnabledPaymentMethods);
  const dispatch = useAppDispatch();

  if (!member || !enabledPaymentMethods.includes(PAYMENT_METHOD.SAVED_CARD)) {
    return null;
  }

  const toggle = () => {
    if (checkoutInProgress) return;
    dispatch(setRememberCreditCard(!rememberCreditCard));
    logEvent(EVENTS.CHANGE_REMEMBER_CARD_OPTION);
  };

  return (
    <div
      style={{
        ...styles.saveCardContainer,
        ...(checkoutInProgress ? styles.disabled : {}),
      }}
    >
      <Switch
        disabled={!member || checkoutInProgress}
        checked={rememberCreditCard}
        onChange={toggle}
      />
      <TouchableOpacity onClick={toggle}>
        <Text themeKey="paymentMethod" style={{ margin: 0, paddingLeft: 10 }}>
          Save Card
        </Text>
      </TouchableOpacity>
    </div>
  );
};

const styles: Styles = {
  saveCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  saveCardIcon: {
    marginRight: 5,
  },
  disabled: {
    opacity: 0.5,
  },
};

export default SaveCardSwitch;
